import React, { Component } from "react";
import { connect } from "react-redux";
import { openSwAction } from "../../redux/ui/actions";
import { changeSwModeAction, changeInPredictAction, finLrnAction, changeInExeWaitngAction, changeWaitngTimeAction } from "../../redux/app/actions";
import { changeUseChkAction } from "../../redux/boring/actions";
import { changeGeoInfoAction, changeModelDepAction } from "../../redux/lrn/actions";
import Sw from "../common/Sw";
import Select from "../common/Select";
import Text from "../common/Text";

const mapStateToProps = state => {
  return {
    swMode: state.appReducer.swMode,
    geoDs: state.geoReducer.dataset,
    boringDs: state.boringReducer.dataset,
    coord: state.modelAreaReducer.coord,
    geoInfo: state.lrnReducer.geoInfo,
    modelDep: state.lrnReducer.modelDep,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.geoInfoOpt = [];
    this.props.geoDs.forEach((el, index) => {
      this.geoInfoOpt.push({ val: index, text: el.name });
    });

    this.closeSw = this.closeSw.bind(this);
    this.doExe = this.doExe.bind(this);
    this.changeUseChk = this.changeUseChk.bind(this);

    //TODO:現状ではユーザIDは0で固定
    const origin = window.location.origin;
    const search = window.location.search;
    this.tmpURL = `${origin}/api/user/0/model${search}`;

    this.state = {
      useModel: 0,
    };
  }

  /*
   * サブウィンドウを閉じる
   * @since hara 2020-09-09
   */
  closeSw() {
    this.props.dispatch(openSwAction(null));
    this.props.dispatch(changeSwModeAction(0));
  }

  /*
   * 推定実行
   * @since kawai 2020-09-09
   */
  async doExe() {
    /*
     * 入力値確認
     */
    let useChk = true;
    this.props.boringDs.forEach(el => {
      if (el.use) useChk = false;
    });
    if (useChk) {
      alert("推定に使用するボーリングデータセットを1つ以上選択してください。");
      return;
    }
    if (this.props.modelDep < 1 || 1000 < this.props.modelDep) {
      alert("モデル深度は 1~1000 の範囲で設定してください。");
      return;
    }
    await this.doCheckExe();

    /*
     * 推定
     */
    const waiting = stat => {
      this.props.dispatch(changeInPredictAction(stat));
    };
    waiting(true);

    //チェックされたボーリングの情報を取得
    //boringDsのuseプロパティを使用するよう修正 @since hara 2020-10-08
    let selectedBoring = [];
    this.props.boringDs.forEach(el => {
      if (el.use) {
        selectedBoring.push({
          ID: el["ID"],
          name: el["name"],
        });
      }
    });

    console.log(JSON.stringify(selectedBoring));

    //実行可否を確認する

    //サーバへ指定したボーリングを使用して学習を行うように要求
    await fetch(`${this.tmpURL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // クッキーを含める
      body: JSON.stringify({
        selectedBoring: selectedBoring,
        //モデル領域機能で選択した領域でモデルを作成する
        range: {
          x1: this.props.coord[2],
          x2: this.props.coord[3],
          y1: this.props.coord[1],
          y2: this.props.coord[0],
        },
        grouping: this.props.geoDs[0].geo.length == 13 ? false : true,
        exe: "learn",
      }),
    })
      .then(res => res.json())
      .then(res => {
        if (res.result == "limit") {
          alert("現在サーバーが混み合っております。時間を空けて再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "outside") {
          alert("対応範囲外です。お手数ですが、位置を変更し再実行してください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (JSON.parse(res).result == "timeout") {
          alert("タイムアウトエラーが発生しました。学習領域を狭くし、再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "fetcherror") {
          alert("サーバー内部エラーが発生しました。システム管理者に確認してくだい。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "outside") {
          alert("対応範囲外です。お手数ですが、位置を変更し再実行してください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (JSON.parse(res).result == "nodata") {
          alert("学習データがありません。推定に使用するボーリングを変更するか、学習領域を変更し再実行してください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else {
          console.log("doExe done");
          //予測位置サブウィンドウを開けるようにする
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
          this.props.dispatch(finLrnAction(true));
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
        waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * ボーリングを推定に使用チェック変更
   * @param {Event} e イベント情報
   * @since hara 2020-10-08
   */
  changeUseChk(e) {
    const val = e.target.value;
    const chk = e.target.checked;
    const ds = this.props.boringDs[val - 1];
    ds.use = chk;

    this.props.dispatch(changeUseChkAction(val, ds));
  }

  /*
   * 実行可否を確認
   * @since ando 2025-07-31
   */
  async doCheckExe() {
    const origin = window.location.origin;
    const search = window.location.search;

    try {
      const res = await fetch(`${origin}/api/0/checkExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "estBoring",
        }),
      });

      const json = await res.json();
      console.log("res", json);

      if (json.result === "OK") {
        return true; // 処理可能
      } else {
        this.props.dispatch(changeWaitngTimeAction(json.waiting_time));
        this.props.dispatch(changeInExeWaitngAction(true)); // GUI表示
        return false; // 待機状態
      }
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      return false; // エラー時も止める
    }
  }

  render() {
    let tList = [];
    this.props.boringDs.forEach(el => {
      if (el.geoInfo === this.props.geoInfo) {
        tList.push(
          <tr key={el.ID}>
            <td>{el.ID}</td>
            <td>{window.abbreText(el.name, 23)}</td>
            <td style={{ backgroundColor: el.color }}></td>
            {/*★ここから公開版で削除*/}
            {
              <td className="l-textCenter">
                <input id={"estGeoMain_useChk" + el.ID} className="check" type="checkbox" value={el.ID} onChange={this.changeUseChk} checked={el.use} />
                <label htmlFor={"estGeoMain_useChk" + el.ID}></label>
              </td>
            }
            {/*★ここまで公開版で削除*/}
          </tr>
        );
      }
    });

    return (
      <Sw title="学習実行" focusName="lrn">
        <fieldset className="Unit">
          <legend>ボーリング</legend>
          {<Select label="地質情報" options={this.geoInfoOpt} value={this.props.geoInfo} class="selectM" blank={false} action={changeGeoInfoAction} />}
          {/*★公開版で削除*/}

          <div className="TWrap l-mtS" style={{ overflowY: "scroll" }}>
            <table className="autoTable">
              <thead>
                <tr>
                  <th className="tsS">ID</th>
                  <th className="tsM">名称</th>
                  <th className="tsS">カラー</th>
                  {<th>推定に使用</th>}
                  {/*★公開版で削除*/}
                </tr>
              </thead>
              <tbody>{tList}</tbody>
            </table>
          </div>
        </fieldset>
        {/*<Text label='モデル深度' value={this.props.modelDep} class='textS' mt={true} type='number' action={changeModelDepAction} />*/}
        {/*★公開版で削除*/}

        <div className="l-right l-mtM">
          <button className="cBtn" onClick={this.doExe}>
            実行
          </button>
          <button className="cBtn l-mlS" onClick={this.closeSw}>
            閉じる
          </button>
        </div>
      </Sw>
    );
  }
}

export default connect(mapStateToProps)(Main);
